import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "mobile-nav" }
const _hoisted_3 = { class: "login-wrapper" }
const _hoisted_4 = { class: "login" }
const _hoisted_5 = {
  key: 1,
  class: "logged-in-user"
}
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = { class: "players" }
const _hoisted_8 = { class: "left-side" }
const _hoisted_9 = { class: "right-side" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BloxupLogo = _resolveComponent("BloxupLogo")!
  const _component_MobileMenuModal = _resolveComponent("MobileMenuModal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Ping = _resolveComponent("Ping")!
  const _component_LoginModal = _resolveComponent("LoginModal")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "burger",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass({ open: _ctx.isOpen })
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass({ open: _ctx.isOpen })
          }, null, 2),
          _createElementVNode("span", {
            class: _normalizeClass({ open: _ctx.isOpen })
          }, null, 2)
        ]),
        _createVNode(_component_BloxupLogo),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(_component_MobileMenuModal, {
            isOpen: _ctx.isOpen,
            onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
          }, null, 8, ["isOpen"])
        ]))
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (!_ctx.accessToken)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.commit('auth/SHOW_LOGIN_MODAL', true))),
                style: {"height":"32px","width":"80px","border-radius":"12px"}
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                  _createTextVNode("Login", -1)
                ]))]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: _ctx.user.avatar,
                  alt: _ctx.user.name
                }, null, 8, _hoisted_6),
                _createVNode(_component_Dropdown, { options: _ctx.userOptions }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.user.name), 1)
                  ]),
                  _: 1
                }, 8, ["options"])
              ]))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_Ping),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("global.online_players")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", null, _toDisplayString(_ctx.globalConfig.data.onlineUsersCount?.toLocaleString()), 1)
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "shadow" }, null, -1))
    ]),
    (_ctx.showLoginModal)
      ? (_openBlock(), _createBlock(_component_LoginModal, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$store.commit('auth/SHOW_LOGIN_MODAL', false))),
          img: "Welcome.png",
          name: "Welcome"
        }))
      : _createCommentVNode("", true)
  ]))
}